import { IconCheck } from '@calendly/ui/components/glyphs/IconCheck';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { colorIconInverseStandard } from '@calendly/ui/theme';
import { useEffect } from 'react';
const TOAST_DISMISS_DELAY_MS = 5000;

// Absolutely positioned by the publish-button anchor in editor_header so the
// toast's right edge stays flush with the Saved button regardless of shell padding.
const wrapperCss = "w1haa4bv";
const pillCss = "p1i3zziw";
const messageCss = "m1s1qnyj";
export const EditorToast = ({
  message,
  icon = IconCheck,
  onDismiss
}) => {
  useEffect(() => {
    const timer = setTimeout(onDismiss, TOAST_DISMISS_DELAY_MS);
    return () => clearTimeout(timer);
  }, [onDismiss]);
  return <div className={wrapperCss} data-testid="editor-toast">
      <div className={pillCss} role="status">
        <UiIcon icon={icon} size="small" color={colorIconInverseStandard} title="" />
        <span className={messageCss}>{message}</span>
      </div>
    </div>;
};

require("./editor_toast.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./editor_toast.js");